import { createContext, useContext } from "react";
import { useApiContext } from "./ApiContext";
const CoreContext = createContext();
export default function ContextCore({children}){
    const {init}=useApiContext();
    const loadConfig=async ()=>{
        return new Promise((rs,rj)=>{
            const {location}=window;
            const config_url=`${location.protocol}//${location.host}/cfg/${location.hostname}/config.js`;
            const script=Array.from(document.head.querySelectorAll('script')).find((s)=>s.src===config_url);
            if(!script){
                const script=document.createElement("script");
                script.onload=()=>{
                    const {global}=window;
                    if(global){
                        return rs(global);
                    }else{
                        return rj('nessuna configurazione')
                    }
                };
                script.onerror=rj;                
                script.src=config_url;
                document.body.appendChild(script);

    
            }
        });
    }
    const initConfig=(config)=>{
        init(config);        
    }
    return (
        <CoreContext.Provider value={{loadConfig,initConfig}}>
            {children}
        </CoreContext.Provider>
    )
}
export const useCoreContext = () => useContext(CoreContext);